import tour from "./tour_icon_24px.png";

export const TourIcon = () => (
  <img src={tour} height={24} width={24} alt="Tour icon" />
);
